import React, { useRef } from "react";

import { Col, Container, Row } from "react-bootstrap";


import android from "../images/ic kang/ic_android.png";
import kotlin from "../images/ic kang/ic_kotlin.png";
import java from "../images/ic kang/ic_java.jpg";
import js from "../images/ic kang/ic_js.png";
import html from "../images/ic kang/ic_html_css.png";
import python from "../images/ic kang/ic_py.png";

import OwlCarousel from "react-owl-carousel2";

const options = {
  items: 3,
  nav: false,
  rewind: true,
  autoplay: true,
  margin: 10,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 4,
    },
    1000: {
      items: 4,
      loop: false,
    },
  },
};

const events = {
  onDragged: function (event) {
    console.log("onDragged: " + event.type);
  },
  onChanged: function (event) {
    console.log("onDragged: " + event.type);
  },
  onTranslate: function (event) {
    console.log("onDragged: " + event.type);
  },
};

const Courses = () => {
  const carRef = useRef();

  return (
    <section id="courses">
      <Container>
        <Row>
          <Col md={12} sm={12}>
            <div className="section-title">
              <h1>Popular Courses</h1>
            </div>
          </Col>
        </Row>
        <OwlCarousel
          className="owl-carousel owl-theme"
          ref={carRef}
          options={options}
          events={events}
        >
          <Col sm={4} md={4}>
            <div className="item">
              <div class="courses-thumb">
                <div className="courses-top">
                  <div className="courses-image">
                    <img src={python} className="img-responsive" alt="" />
                  </div>
                  <div className="courses-date">
                    <span>
                      <i className="fa fa-clock-o"></i> 2-3 Months
                    </span>
                  </div>
                </div>

                <div className="courses-detail">
                  <h3>
                    Python Programming
                  </h3>
                  <p>
                    Basic to adavance python Programming training with NumPy,
                    Pandas, SciKitlearn, Matplotlib etc
                  </p>
                </div>
                <div className="courses-price">
                  <a href="#contact">
                    <span>Enroll Now</span>
                  </a>
                </div>
                <div className="courses-info"></div>
              </div>
            </div>
          </Col>

          <Col sm={4} md={4}>
            <div className="item">
              <div class="courses-thumb">
                <div className="courses-top">
                  <div className="courses-image">
                    <img src={android} className="img-responsive" alt="" />
                  </div>
                  <div className="courses-date">
                    <span>
                      <i className="fa fa-clock-o"></i> 3-4 Months
                    </span>
                  </div>
                </div>

                <div className="courses-detail">
                  <h3>
                    Android Development
                  </h3>
                  <p>
                    From basic to advance level guidence with live project work
                    training{" "}
                  </p>
                </div>
                <div className="courses-price">
                  <a href="#contact">
                    <span>Enroll Now</span>
                  </a>
                </div>
                <div className="courses-info"></div>
              </div>
            </div>
          </Col>

          <Col sm={4} md={4}>
            <div className="item">
              <div class="courses-thumb">
                <div className="courses-top">
                  <div className="courses-image">
                    <img src={java} className="img-responsive" alt="" />
                  </div>
                  <div className="courses-date">
                    <span>
                      <i className="fa fa-clock-o"></i> 2-3 Months
                    </span>
                  </div>
                </div>

                <div className="courses-detail">
                  <h3>
                    Java Programming
                  </h3>
                  <p>
                    Java Programming training with real world problem solutions
                  </p>
                </div>
                <div className="courses-price">
                  <a href="#contact">
                    <span>Enroll Now</span>
                  </a>
                </div>
                <div className="courses-info"></div>
              </div>
            </div>
          </Col>

          <Col sm={4} md={4}>
            <div className="item">
              <div class="courses-thumb">
                <div className="courses-top">
                  <div className="courses-image">
                    <img src={kotlin} className="img-responsive" alt="" />
                  </div>
                  <div className="courses-date">
                    <span>
                      <i className="fa fa-clock-o"></i> 2-3 Months
                    </span>
                  </div>
                </div>

                <div className="courses-detail">
                  <h3>
                    Kotlin Programming
                  </h3>
                  <p>
                    Kotlin Programming training from basic to advance with
                    problem solving scenario
                  </p>
                </div>
                <div className="courses-price">
                  <a href="#contact">
                    <span>Enroll Now</span>
                  </a>
                </div>
                <div className="courses-info"></div>
              </div>
            </div>
          </Col>

          <Col sm={4} md={4}>
            <div className="item">
              <div class="courses-thumb">
                <div className="courses-top">
                  <div className="courses-image">
                    <img src={html} className="img-responsive" alt="" />
                  </div>
                  <div className="courses-date">
                    <span>
                      <i className="fa fa-clock-o"></i> 2-3 Months
                    </span>
                  </div>
                </div>

                <div className="courses-detail">
                  <h3>
                    Web Designing
                  </h3>
                  <p>
                    Web Designing training using HTML5-CSS3 and website template
                    creation and more
                  </p>
                </div>
                <div className="courses-price">
                  <a href="#contact">
                    <span>Enroll Now</span>
                  </a>
                </div>
                <div className="courses-info"></div>
              </div>
            </div>
          </Col>

          <Col sm={4} md={4}>
            <div className="item">
              <div class="courses-thumb">
                <div className="courses-top">
                  <div className="courses-image">
                    <img src={js} className="img-responsive" alt="" />
                  </div>
                  <div className="courses-date">
                    <span>
                      <i className="fa fa-clock-o"></i> 2-3 Months
                    </span>
                  </div>
                </div>

                <div className="courses-detail">
                  <h3>
                    JavaScript Programming
                  </h3>
                  <p>
                    Web application Development using JavaScript with mini
                    project Development guidence
                  </p>
                </div>
                <div className="courses-price">
                  <a href="#contact">
                    <span>Enroll Now</span>
                  </a>
                </div>
                <div className="courses-info"></div>
              </div>
            </div>
          </Col>
        </OwlCarousel>
      </Container>
    </section>
  );
};

export default Courses;
